import { useState, useEffect } from 'react';
import OptionsRangeFilter from '@/components/filters/OptionsRangeFilter/OptionsRangeFilter';
import { getRelativeDate, getCurrentDate } from '@/helpers/dateHelper';

interface DateFilterProps {
  dateRange: { from: string; to: string } | null;
  onDateRangeChange: (range: { from: string; to: string } | null) => void;
  /** SPR-1212 / HAT-1212: refetch בעמוד → disabled ויזואלי ללוח התאריכים. */
  isBusy?: boolean;
}

// Default date range: last 30 days
const DEFAULT_DATE_RANGE = {
  from: getRelativeDate(-29),
  to: getCurrentDate(),
};

const DateFilter = ({ dateRange, onDateRangeChange, isBusy }: DateFilterProps) => {
  const [fromValue, setFromValue] = useState<string>(DEFAULT_DATE_RANGE.from);
  const [toValue, setToValue] = useState<string>(DEFAULT_DATE_RANGE.to);
  const [appliedRange, setAppliedRange] = useState<{ from: string; to: string } | null>(DEFAULT_DATE_RANGE);

  // Initialize with default date range on mount
  useEffect(() => {
    if (dateRange === null) {
      onDateRangeChange(DEFAULT_DATE_RANGE);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Sync local state with prop changes
  useEffect(() => {
    if (dateRange) {
      setFromValue(dateRange.from);
      setToValue(dateRange.to);
      setAppliedRange(dateRange);
    }
  }, [dateRange]);

  const handleRangeApply = (from: string, to: string) => {
    onDateRangeChange({ from, to });
  };

  return (
    <OptionsRangeFilter
      title="dateRange"
      filterType="range"
      rangeConfig={{
        type: 'date',
        fromPlaceholder: 'fromDate',
        toPlaceholder: 'toDate',
      }}
      fromValue={fromValue}
      setFromValue={setFromValue}
      toValue={toValue}
      setToValue={setToValue}
      appliedRange={appliedRange}
      setAppliedRange={setAppliedRange}
      onRangeApply={handleRangeApply}
      showMonthNavigation
      hebrewCalendar
      isBusy={isBusy}
    />
  );
};

export default DateFilter;
